import { cn } from "@/lib/utils";
import { Spinner } from "@/components/ui/Spinner";
import { GlobalLoaderProps } from "./types";

const GlobalLoader = ({ isVisible }: GlobalLoaderProps) => {
  if (!isVisible) return null;

  return (
    <div
      className={cn(
        "fixed inset-0 z-[99999999] flex items-center justify-center bg-black/60 backdrop-blur-sm",
        "duration-200 animate-in fade-in-0",
      )}
      style={{ pointerEvents: "all" }}
      role="status"
      aria-live="polite"
      aria-label="Loading..."
    >
      <div className="flex flex-col items-center gap-4">
        <Spinner size="xl" color="white" />
        <p className="text-sm text-white/80">Loading...</p>
      </div>
    </div>
  );
};

export default GlobalLoader;
